import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function FeaturedEquipment() {
  return <section className="w-full bg-brand-dark py-16 md:py-24 border-t border-brand-border" aria-labelledby="featured-heading" data-id="element-60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-61">
        {/* Section Header */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-12 md:mb-16 gap-4" data-id="element-62">
          <div data-id="element-63">
            <h2 id="featured-heading" className="font-oswald font-bold text-[28px] sm:text-3xl md:text-4xl lg:text-5xl uppercase tracking-wide text-white mb-2" data-id="element-64">
              Featured Equipment
            </h2>
            <p className="text-brand-muted text-base md:text-lg" data-id="element-65">
              Hand-picked machines ready to work. Updated weekly.
            </p>
          </div>
          <a href="#equipment" className="inline-flex items-center gap-2 text-brand-orange font-oswald font-semibold uppercase tracking-wider text-sm hover:underline min-h-[48px]" data-id="element-66">
            View All Inventory
            <ArrowRightIcon className="w-4 h-4" aria-hidden="true" data-id="element-67" />
          </a>
        </div>

        {/* Equipment Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-68">
          {/* Card 1 — Bobcat E35 */}
          <div className="bg-brand-card rounded-lg overflow-hidden border border-brand-border group hover:border-brand-orange/50 transition-colors duration-300" data-id="element-69">
            <div className="aspect-[4/3] overflow-hidden" data-id="element-70">
              <img src="https://cdn.magicpatterns.com/uploads/5Gew9WRCiu9uwZr949ot8Q/2019_bobcat_e35.jpg" alt="2019 Bobcat E35 Mini Excavator" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-71" />
            </div>
            <div className="p-5" data-id="element-72">
              <h3 className="font-oswald font-semibold text-lg text-white uppercase mb-1" data-id="element-73">
                2019 Bobcat E35 Mini Excavator
              </h3>
              <p className="text-brand-muted text-sm mb-3" data-id="element-74">
                2,000 hrs &bull; 24.9HP &bull; Kubota Diesel &bull; Long Arm
                &bull; 3 Buckets &bull; 2 Speed
              </p>
              <p className="font-oswald font-bold text-xl text-brand-orange mb-4" data-id="element-75">
                $35,000 OBO
              </p>
              <a href="#contact" className="inline-flex items-center gap-1.5 text-sm text-brand-orange font-semibold hover:underline min-h-[48px]" data-id="element-76">
                View Details
                <ArrowRightIcon className="w-4 h-4" aria-hidden="true" data-id="element-77" />
              </a>
            </div>
          </div>

          {/* Card 2 — CAT 232D */}
          <div className="bg-brand-card rounded-lg overflow-hidden border border-brand-border group hover:border-brand-orange/50 transition-colors duration-300" data-id="element-78">
            <div className="aspect-[4/3] overflow-hidden" data-id="element-79">
              <img src="https://cdn.magicpatterns.com/uploads/oivAGXf1CRG5Ap9tEo3pkM/2019_cat.jpg" alt="2019 CAT 232D Skid Steer" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-80" />
            </div>
            <div className="p-5" data-id="element-81">
              <h3 className="font-oswald font-semibold text-lg text-white uppercase mb-1" data-id="element-82">
                2019 CAT 232D Skid Steer
              </h3>
              <p className="text-brand-muted text-sm mb-3" data-id="element-83">
                2,200 hrs &bull; 67HP &bull; CAT Diesel &bull; One Speed &bull;
                Pilot Control &bull; 68" Bucket
              </p>
              <p className="font-oswald font-bold text-xl text-brand-orange mb-4" data-id="element-84">
                $31,000 OBO
              </p>
              <a href="#contact" className="inline-flex items-center gap-1.5 text-sm text-brand-orange font-semibold hover:underline min-h-[48px]" data-id="element-85">
                View Details
                <ArrowRightIcon className="w-4 h-4" aria-hidden="true" data-id="element-86" />
              </a>
            </div>
          </div>

          {/* Card 3 — John Deere 210LEP */}
          <div className="bg-brand-card rounded-lg overflow-hidden border border-brand-border group hover:border-brand-orange/50 transition-colors duration-300" data-id="element-87">
            <div className="aspect-[4/3] overflow-hidden" data-id="element-88">
              <img src="https://cdn.magicpatterns.com/uploads/tD6agySU4rchktMxeFyfae/2017_john_deere.jpg" alt="2017 John Deere 210LEP Skip Loader" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-89" />
            </div>
            <div className="p-5" data-id="element-90">
              <h3 className="font-oswald font-semibold text-lg text-white uppercase mb-1" data-id="element-91">
                2017 John Deere 210LEP Skip Loader
              </h3>
              <p className="text-brand-muted text-sm mb-3" data-id="element-92">
                3,000 hrs &bull; 74HP &bull; 4.5L Deere Diesel &bull; 4WD &bull;
                Dual Rear Tilt Gannon Box
              </p>
              <p className="font-oswald font-bold text-xl text-brand-orange mb-4" data-id="element-93">
                $43,000 OBO
              </p>
              <a href="#contact" className="inline-flex items-center gap-1.5 text-sm text-brand-orange font-semibold hover:underline min-h-[48px]" data-id="element-94">
                View Details
                <ArrowRightIcon className="w-4 h-4" aria-hidden="true" data-id="element-95" />
              </a>
            </div>
          </div>

          {/* Card 4 — Ford F150 */}
          <div className="bg-brand-card rounded-lg overflow-hidden border border-brand-border group hover:border-brand-orange/50 transition-colors duration-300" data-id="element-96">
            <div className="aspect-[4/3] overflow-hidden" data-id="element-97">
              <img src="https://cdn.magicpatterns.com/uploads/kr3djezHnrqtW5pwcECJcd/2017_ford.jpg" alt="2017 Ford F150 Crew Cab Lariat" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-98" />
            </div>
            <div className="p-5" data-id="element-99">
              <h3 className="font-oswald font-semibold text-lg text-white uppercase mb-1" data-id="element-100">
                2017 Ford F150 Crew Cab Lariat
              </h3>
              <p className="text-brand-muted text-sm mb-3" data-id="element-101">
                129K mi &bull; 2.7 Ecoboost &bull; 10 Speed Auto &bull; FX4
                Package &bull; 4x4 &bull; Leather
              </p>
              <p className="font-oswald font-bold text-xl text-brand-orange mb-4" data-id="element-102">
                $25,000 OBO
              </p>
              <a href="#contact" className="inline-flex items-center gap-1.5 text-sm text-brand-orange font-semibold hover:underline min-h-[48px]" data-id="element-103">
                View Details
                <ArrowRightIcon className="w-4 h-4" aria-hidden="true" data-id="element-104" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}